import { motion, useIsPresent } from "framer-motion";

import Intro from "../components/Intro";

export function Home() {
  const isPresent = useIsPresent();

  return (
    <>
      <Intro />
      {/* (s) 페이지 전환 애니메이션 */}
      <motion.div
        initial={{ scaleY: 1 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
        exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn" } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="transition-screen-step1"
      />
      <motion.div
        initial={{ scaleY: 1 }}
        animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut", delay: 0.1 } }}
        exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn", delay: 0.1 } }}
        style={{ originY: isPresent ? 0 : 1 }}
        className="transition-screen-step2"
      />
      {/* (e) 페이지 전환 애니메이션 */}
    </>
  );
}
